var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModalUpdateUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.08,
    cy: 36.08,
    r: 36.08,
    fill: "#5754E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.08,
    cy: 36.08,
    r: 36.08,
    fill: "#5754E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0801 35.5801C12.0801 27.3305 12.0801 23.2057 14.8918 20.6429C17.7036 18.0801 22.2291 18.0801 31.2801 18.0801H40.8801C49.931 18.0801 54.4566 18.0801 57.2682 20.6429C60.0801 23.2057 60.0801 27.3305 60.0801 35.5801C60.0801 43.8296 60.0801 47.9545 57.2682 50.5172C54.4566 53.0801 49.931 53.0801 40.8801 53.0801H31.2801C22.2291 53.0801 17.7036 53.0801 14.8918 50.5172C12.0801 47.9545 12.0801 43.8296 12.0801 35.5801Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8301 26.8301H52.8301",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8301 32.8301H52.8301",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7803 31.5552C32.7803 28.3795 30.2059 25.8052 27.0303 25.8052C23.8546 25.8052 21.2803 28.3795 21.2803 31.5552C21.2803 34.7308 23.8546 37.3052 27.0303 37.3052C30.2059 37.3052 32.7803 34.7308 32.7803 31.5552Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9805 45.3552C18.9805 40.9093 22.5846 37.3052 27.0305 37.3052C28.4967 37.3052 29.8714 37.6972 31.0555 38.3822",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9297 41.2032C33.9297 40.0307 34.9594 39.0801 36.2297 39.0801C37.5 39.0801 38.5297 40.0307 38.5297 41.2032C38.5297 41.6258 38.3959 42.0196 38.1653 42.3504C37.4779 43.3365 36.2297 43.7018 36.2297 44.8744V45.4051M36.2184 48.2801H36.2288",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalUpdateUser);
export default __webpack_public_path__ + "static/media/iconModalUpdateUser.2922358aeac73167de94c76929b47097.svg";
export { ForwardRef as ReactComponent };